import {initWebComponent} from "@/helpers/web-component-helper";
import $ from "jquery";
// import * as bootstrap from "bootstrap";

export class BookmarkUserSessionUpdateNameButtonComponent extends HTMLElement {
    constructor(){
        super();

        const id = this.getAttribute('data-id')

        const template = document.createElement('template');

        // template.innerHTML = `<button class="btn btn-sm borderless icon-btn popper-header" data-bs-toggle="modal" data-bs-target="#mdlSession">
        //       <i class="fa fa-edit"></i>
        //       <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
        //          Sessie naam bewerken
        //         <div class="arrow" data-popper-arrow=""></div>
        //       </div>
        //     </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            //TODO
        })
    }
}
